import { nanoid } from 'nanoid';

export function getCart(root) {
	const cartContents = fetch(`${root}cart.js`)
		.then(res => res.json())
		.then(data => data)
		.catch(err => console.error(err.message));
}

export function addBundleToCart({ variant_id, qty, bundle_key, frame }) {
	const _bundle_key = nanoid();

	const items = [
		{
			id: '',
			quantity: 1,
			properties: {
				_bundle_key,
				_prescriptionType: '',
				_readerStrength: '',
				_customerType: '',
				_customerJourney: '',
				_submissionMethod: '',
			},
		},
	];

	// console.log('add call from cart service.');

	const formData = {
		items: [
			{
				id: variant_id,
				quantity: qty,
				...(bundle_key && { properties: { _bundle_key: bundle_key.toString() } }),
			},
		],
	};

	// let result = fetch("/cart/add.js", {
	//     method: "POST",
	//     headers: {
	//         "Content-Type": "application/json",
	//     },
	//     body: JSON.stringify(formData),
	// })
	//     .then(response => response.json())
	//     .then(data => {
	//         return data;
	//     })
	//     .catch(error => {
	//         console.error("Error:", error);
	//     });

	// return result;
}

export const uploadPrescription = formData => {
	return fetch(`${process.env.POMS_URL}/api/prescription/upload`, {
		method: 'POST',
		contentType: false,
		processData: false,
		body: formData,
	})
		.then(response => response)
		.catch(error => error);
};

export const updateFreeShippingProgressBar = cartTotal => {
	const className = 'free-shipping-progress-bar';

	const el = document.getElementById('FreeShippingProgressBar');
	const el_descriptionUnderThreshold = el.querySelector(`.${className}__description-under-threshold`);
	const el_descriptionMeetsThreshold = el.querySelector(`.${className}__description-meets-threshold`);
	const el_remainingAmount = el_descriptionUnderThreshold.querySelector('span');
	const el_progressBar = el.querySelector(`.${className}__progress`);

	const threshold = el.getAttribute('data-free-shipping-threshold');
	const remaining = threshold - cartTotal;
	const isThresholdReached = remaining <= 0;

	if (!isThresholdReached) {
		el_remainingAmount.textContent = `$${parsePriceFixedTwo(threshold - cartTotal)}`;
		el_descriptionUnderThreshold.style.opacity = 1;
		el_descriptionMeetsThreshold.style.opacity = 0;
	} else {
		el_descriptionUnderThreshold.style.opacity = 0;
		el_descriptionMeetsThreshold.style.opacity = 1;
	}

	el_progressBar.style.width = isThresholdReached ? '100%' : `${((threshold - remaining) / threshold) * 100}%`;
};
